document.addEventListener('DOMContentLoaded', function() {
  const faqLink = document.querySelector('.open-widget');
  if (faqLink) {
    faqLink.style.display = 'block';
  }
  //顶部
  const chatLink1 = document.querySelector('.announcement-bar--item a[href="#live-chat"]');
  if (chatLink1) {
    chatLink1.innerHTML = chatLink1.innerHTML.replace('here', '<u>here</u>');
    chatLink1.addEventListener('click', function(e) {
      e.preventDefault();
      LiveChatWidget.on('ready', function() {LiveChatWidget.call("maximize");});
    });
  }
  //产品header
  const chatLink2 = document.querySelector('.all-headers a[href="#live-chat"]');
  if (chatLink2) {
    chatLink2.addEventListener('click', function(e) {
      e.preventDefault();
      LiveChatWidget.on('ready', function() {LiveChatWidget.call("maximize", { messageDraft: "Do you offer curtains in other headers?" });});
    });
  }
  //通用
  const chatLink3 = document.querySelector('.livechat a[href="#live-chat"]');
  if (chatLink3) {
    chatLink3.innerHTML = chatLink3.innerHTML.replace('here', '<u>here</u>');
    chatLink3.addEventListener('click', function(e) {
      e.preventDefault();
      LiveChatWidget.on('ready', function() {LiveChatWidget.call("maximize");});
    });
  }

  // 检查当前页面路径，如果不是购物车页面，则触发幽灵动画
  // if ((window.location.pathname=='/' 
  //   || window.location.pathname.includes('/collections')
  //   || window.location.pathname.includes('/halloween-sale'))
  //   && !window.location.pathname.includes('/products')
  // ) {
    
  //   createAndAnimateGhosts();
  // }

  blackmenu();
});

function blackmenu() {
  // Find the sub-menu that contains "Limited Time Only"
  const subMenus = document.querySelectorAll('ul.sub-menu');
  
  subMenus.forEach(subMenu => {
    // Find the "Limited Time Only" list item
    const limitedTimeLi = Array.from(subMenu.querySelectorAll('li')).find(li => {
      return li.textContent.includes('Limited Time Only') && 
             li.querySelector('details') && 
             li.querySelector('summary');
    });

    if (limitedTimeLi) {
      // Get the details element and the submenu within it
      const details = limitedTimeLi.querySelector('details');
      const innerSubMenu = details.querySelector('ul.sub-menu');

      if (innerSubMenu) {
        // Get all li elements starting from the 3rd one (index 2)
        const allInnerLis = innerSubMenu.querySelectorAll('li');
        const lisToReplaceWith = Array.from(allInnerLis).slice(2); // Start from 3rd li

        if (lisToReplaceWith.length > 0) {
          // Store subsequent siblings before replacement
          const siblingsToRemove = [];
          let nextSibling = limitedTimeLi.nextElementSibling;
          while (nextSibling) {
            if (nextSibling.tagName === 'LI') { // Ensure it's an LI element
              siblingsToRemove.push(nextSibling);
            }
            nextSibling = nextSibling.nextElementSibling;
          }

          // Create a document fragment to hold the new elements
          const fragment = document.createDocumentFragment();

          // Clone and add each li to the fragment
          lisToReplaceWith.forEach(li => {
            const clonedLi = li.cloneNode(true);
            fragment.appendChild(clonedLi);
          });

          // Replace the "Limited Time Only" li with the new lis
          limitedTimeLi.parentNode.replaceChild(fragment, limitedTimeLi);

          // Remove the subsequent siblings
          siblingsToRemove.forEach(sibling => {
            sibling.remove();
          });
        }
      }
    }
  });
}

function createAndAnimateGhosts() {
  const ghostImages = [
    "https://cdn.shopify.com/s/files/1/0869/4575/9543/files/ghost1.png?v=1758009455",
    "https://cdn.shopify.com/s/files/1/0869/4575/9543/files/ghost3.png?v=1758009456",
    "https://cdn.shopify.com/s/files/1/0869/4575/9543/files/ghost2.png?v=1758009456",
    "https://cdn.shopify.com/s/files/1/0869/4575/9543/files/ghost4.png?v=1758078373",
    "https://cdn.shopify.com/s/files/1/0869/4575/9543/files/ghost5.png?v=1758078373"
  ];

  const ghosts = [];
  const ghostWidth = 50; // Approximate width of the ghost image
  const ghostHeight = 50; // Approximate height of the ghost image
  const topExclusion = 50; // Avoid top 50px area

  // Calculate number of ghosts based on scrollable height and viewport height
  // Aim for roughly 2 ghosts per viewport height
  const viewportHeight = window.innerHeight;
  const scrollHeight = document.documentElement.scrollHeight;
  const numGhosts = Math.ceil((scrollHeight / viewportHeight) * 2);

  // We want exactly 10 ghosts, using each of the 5 images twice.
  let finalNumGhosts = Math.ceil((scrollHeight / viewportHeight) * 2); // Base on 2 ghosts per viewport

  // Ensure a minimum number of ghosts (at least 2 to maintain the 'per screen' idea)
  finalNumGhosts = Math.max(finalNumGhosts, 2);

  // Adjust for mobile devices if the calculated number is too high
  // if (isMobileDevice()) {
  //   finalNumGhosts = Math.min(finalNumGhosts, 4); // Cap at 4 ghosts for mobile to avoid overcrowding
  // }

  for (let i = 0; i < finalNumGhosts; i++) {
    const img = document.createElement('img');
    img.src = ghostImages[Math.floor(Math.random() * ghostImages.length)]; // Randomly assign any ghost image
    img.classList.add('floating-ghost'); // Add a class for styling
    img.style.position = 'absolute';
    img.style.width = `${ghostWidth}px`;
    img.style.height = 'auto';
    img.style.zIndex = '20';
    img.style.pointerEvents = 'none';

    let x, y;

    // Determine which "screen" segment this ghost belongs to
    const screenSegmentIndex = Math.floor(i / 2); // 0 for ghosts 0,1; 1 for ghosts 2,3; etc.

    // Calculate the base Y position for this screen segment
    // This ensures that ghosts are distributed across the entire scrollable height
    // with a density of approximately 2 per screen height.
    const baseScreenY = screenSegmentIndex * window.innerHeight;

    // Randomize Y within this screen segment, respecting topExclusion
    // and ensuring it doesn't go below the document scroll height.
    let minYInSegment = baseScreenY + topExclusion;
    let maxYInSegment = baseScreenY + window.innerHeight - ghostHeight;

    // Adjust for the total document scroll height
    maxYInSegment = Math.min(maxYInSegment, document.documentElement.scrollHeight - ghostHeight);

    // Ensure minYInSegment is not greater than maxYInSegment
    if (minYInSegment > maxYInSegment) {
      // Fallback if the segment is too small or at the very bottom
      minYInSegment = Math.max(topExclusion, baseScreenY);
      maxYInSegment = Math.min(document.documentElement.scrollHeight - ghostHeight, baseScreenY + window.innerHeight - ghostHeight);
      if (minYInSegment > maxYInSegment) { // Still an issue, just place it somewhere valid
        minYInSegment = topExclusion;
        maxYInSegment = document.documentElement.scrollHeight - ghostHeight;
      }
    }

    y = minYInSegment + Math.random() * (maxYInSegment - minYInSegment);

    // Randomize X within the window width
    x = Math.random() * (window.innerWidth - ghostWidth);

    // Final boundary checks for x and y
    x = Math.max(0, Math.min(x, window.innerWidth - ghostWidth));
    y = Math.max(topExclusion, Math.min(y, document.documentElement.scrollHeight - ghostHeight));

    img.style.top = `${y}px`;
    img.style.left = `${x}px`;

    document.body.appendChild(img);

    ghosts.push({
      element: img,
      dx: (Math.random() - 0.2) * 1.5 > 0.8 ? (Math.random() - 0.2) * 1.5 : 0.8, // Slightly faster movement
      dy: (Math.random() - 0.2) * 2 > 1 ? (Math.random() - 0.2) * 2 : 1,
      minY: minYInSegment, // Store the vertical movement boundaries
      maxY: maxYInSegment
    });
    
  }

  function animateGhosts() {
    ghosts.forEach(ghost => {
      let currentTop = parseFloat(ghost.element.style.top);
      let currentLeft = parseFloat(ghost.element.style.left);

      // Update position
      currentTop += ghost.dy;
      currentLeft += ghost.dx;

      // Boundary checking against document dimensions
      const docWidth = document.documentElement.scrollWidth;

      // Get actual dimensions after image is loaded (if not already)
      const actualGhostWidth = ghost.element.offsetWidth || ghostWidth;
      const actualGhostHeight = ghost.element.offsetHeight || ghostHeight;

      if (currentTop <= ghost.minY || (currentTop + actualGhostHeight) >= ghost.maxY) {
        ghost.dy *= -1; // Reverse vertical direction
        if (currentTop <= ghost.minY) currentTop = ghost.minY;
        if ((currentTop + actualGhostHeight) >= ghost.maxY) currentTop = ghost.maxY - actualGhostHeight;
      }
      if (currentLeft <= 0 || (currentLeft + actualGhostWidth) >= docWidth) {
        ghost.dx *= -1; // Reverse horizontal direction
        if (currentLeft <= 0) currentLeft = 0;
        if ((currentLeft + actualGhostWidth) >= docWidth) currentLeft = docWidth - actualGhostWidth;
      }

      ghost.element.style.top = `${currentTop}px`;
      ghost.element.style.left = `${currentLeft}px`;
    });

    requestAnimationFrame(animateGhosts);
  }

  animateGhosts(); // Start the animation
}

function isMobileDevice() {
  return window.innerWidth < 768;
}


// ===== shopify-account dialog: position below button (logged-out only) =====
(function () {
  function setupAccountDialog(el) {
    var shadow = el.shadowRoot;
    if (!shadow) return;

    var old = shadow.querySelector('#ca-dialog-pos');
    if (old) old.remove();

    var posStyle = document.createElement('style');
    posStyle.id = 'ca-dialog-pos';
    shadow.appendChild(posStyle);

    var btn = shadow.querySelector('.account-button');
    var dlg = shadow.querySelector('dialog');
    if (!btn || !dlg) return;

    var resizeTimer = 0;

    function applyPosition() {
      var r = btn.getBoundingClientRect();
      var cx  = Math.round(r.left + r.width / 2);
      var top = Math.round(r.bottom) + 8;
      posStyle.textContent = 'dialog{position:fixed!important;top:' + top + 'px!important;left:' + cx + 'px!important;right:auto!important;margin:0!important;transform:translateX(-50%)!important;}';
      requestAnimationFrame(function () {
        var dw = dlg.getBoundingClientRect().width;
        if (!dw) return;
        var left = Math.max(8, Math.min(cx - Math.round(dw / 2), window.innerWidth - dw - 8));
        posStyle.textContent = 'dialog{position:fixed!important;top:' + top + 'px!important;left:' + left + 'px!important;right:auto!important;margin:0!important;transform:none!important;}';
      });
    }

    new MutationObserver(function () {
      if (dlg.open) applyPosition();
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });

    window.addEventListener('resize', function () {
      if (!dlg.open) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyPosition, 100);
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('shopify-account').forEach(setupAccountDialog);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.customElements) {
    customElements.whenDefined('shopify-account').then(function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(init);
      });
    });
  }
})();
// ===== end shopify-account dialog positioning =====

// ===== custom account dropdown (logged-in) =====
(function () {
  function initDropdown() {
    document.querySelectorAll('.ca-account-wrap').forEach(function (wrap) {
      if (wrap.dataset.caInit) return;
      wrap.dataset.caInit = '1';

      var btn  = wrap.querySelector('.ca-account-btn');
      var menu = wrap.querySelector('.ca-account-menu');
      if (!btn || !menu) return;

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', !open);
        menu.hidden = open;
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) {
          btn.setAttribute('aria-expanded', 'false');
          menu.hidden = true;
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !menu.hidden) {
          btn.setAttribute('aria-expanded', 'false');
          menu.hidden = true;
          btn.focus();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDropdown);
  } else {
    initDropdown();
  }
})();
// ===== end custom account dropdown =====
